export default "__VITE_ASSET__da0f0dda__"